// src/components/intake/IntakeSection23Screen.js
//
// Ticket 064 (Advisor Intake I5). Renders ONE Section 2 or 3 screen inside the
// shared IntakeShell, like IntakeQuestionScreen does for Section 1. Nothing is
// stored here: every answer goes out through `dispatch` (the reducer) and Next
// asks the page to save. No Skip, and no "Not sure" on any of these screens.

import React from 'react'
import IntakeEvents from './IntakeEvents'
import IntakeIncomeScreen from './IntakeIncomeScreen'
import IntakeSpouseGate from './IntakeSpouseGate'
import IntakeAutonomo from './IntakeAutonomo'
import IntakeBeckham from './IntakeBeckham'
import IntakeSaleLocation from './IntakeSaleLocation'
import IntakeNudges from './IntakeNudges'
import IntakeAccounts from './IntakeAccounts'
import { SECTION23_SCREENS, SAVE_FAILED_NOTICE } from '../../lib/intake/intakeConfig'
import {
  isCardScreen, nudgesFrom,
} from '../../lib/intake/section23Facts'

export default function IntakeSection23Screen({ screenId, state, dispatch, canNext, onNext, nextLabel }) {
  const cfg = SECTION23_SCREENS[screenId]
  const { answers } = state

  function renderBody() {
    if (isCardScreen(screenId)) {
      return (
        <IntakeIncomeScreen
          screenId={screenId}
          answers={answers}
          suggestions={state.suggestions}
          limitHit={state.limitHit}
          onItemsChange={(cardType, owner, items) => dispatch({ type: 'setCardItems', cardType, owner, items })}
          onNone={(value) => dispatch({ type: 'setNone', screen: screenId, value })}
          onSkip={(value) => dispatch({ type: 'setSkip', value })}
          onWorkLocation={(id, value) => dispatch({ type: 'setWorkLocation', id, value })}
        />
      )
    }
    switch (screenId) {
      case '2.1':
        return <IntakeEvents events={answers.events} ownership={answers.ownership} onChange={(events, ownership) => dispatch({ type: 'setEvents', events, ownership })} />
      case '2.3':
        return <IntakeSpouseGate value={answers.spouseHasIncome} onChange={(value) => dispatch({ type: 'setSpouseGate', value })} />
      case '2.4':
        return <IntakeAutonomo autonomo={answers.autonomo} onChange={(autonomo) => dispatch({ type: 'setAutonomo', autonomo })} />
      case '2.5':
        return <IntakeBeckham value={answers.beckham} onChange={(value) => dispatch({ type: 'setBeckham', value })} />
      case '3.3':
        return <IntakeSaleLocation value={answers.saleLocation} onChange={(value) => dispatch({ type: 'setSaleLocation', value })} />
      case '3.4':
        return (
          <IntakeNudges
            nudges={nudgesFrom(state.suggestions, state.dismissed)}
            onDismiss={(key) => dispatch({ type: 'dismissNudge', key })}
          />
        )
      case '4.1':
        return <IntakeAccounts assets={answers.assets} onChange={(key, value) => dispatch({ type: 'setAssets', key, value })} />
      default:
        return null
    }
  }

  return (
    <div>
      <h1 className="triage-question">{cfg.title}</h1>
      {cfg.hint && <p className="triage-hint">{cfg.hint}</p>}
      {state.notice && <p className="intake-notice">{state.notice}</p>}
      {renderBody()}
      {state.saveError && <p className="triage-submit-error" role="alert">{SAVE_FAILED_NOTICE}</p>}
      <div className="intake-actions">
        <button type="button" className="triage-next" onClick={onNext} disabled={!canNext || state.busy}>
          {nextLabel}
        </button>
      </div>
    </div>
  )
}
